import React from 'react';
import Modal from './common/Modal';
import ContactUsForm from './forms/ContactUsForm';

export default (props) => (
  <Modal {...props} showClose={false}>
    <ContactUsForm />
  </Modal>
);
